export default "/_next/static/chunks/fonts/pxiEyp8kv8JHgFVrJJfecg-5224cd4c8d93efc4fd95dfdeb613ab05.woff2";